import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';

import styled from 'styled-components';

interface IProps {
  progress: number;
}

const ProgressBar = ({ progress }: IProps) => {
  return (
    <ProgressBarContainer>
      <LinearProgress value={progress} variant="determinate" />
    </ProgressBarContainer>
  );
};

const ProgressBarContainer = styled.div`
  margin: 10px 0 10px 0;
  @media (max-width: 450px) {
    width: 365px;
  }
`;

export default ProgressBar;
